// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__25nKq","content":"Consent_content__2_vip","footer":"Consent_footer__209U_"};